import { render, staticRenderFns } from "./CustomerAuthorizations.vue?vue&type=template&id=c2e9986a&"
import script from "./CustomerAuthorizations.vue?vue&type=script&lang=js&"
export * from "./CustomerAuthorizations.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAuthorizations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2e9986a')) {
      api.createRecord('c2e9986a', component.options)
    } else {
      api.reload('c2e9986a', component.options)
    }
    module.hot.accept("./CustomerAuthorizations.vue?vue&type=template&id=c2e9986a&", function () {
      api.rerender('c2e9986a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Profile/CustomerAuthorizations.vue"
export default component.exports